module.exports = __webpack_public_path__ + "img/logo_branca_transparente.112d515d.png";